import {
  MeshBasicMaterial,
  Scene,
  Mesh,
  SphereBufferGeometry,
  BackSide
} from 'three'
import { OEEvents } from '../../ts/core/OEEvents'
import { TextureRes } from '../resources/TexturesRes'
import { PANO_CONFIG } from './PanoConfig'
import { PanoSwitch } from './PanoSwitch'
/**
 * 全景图场景
 */
class PanoScene extends Scene {
  constructor(renderMain_, camera_, dom) {
    super()
    this.renderMain = renderMain_
    this.camera = camera_
    this.dom = dom
    this.init()
  }
  init() {
    this.enabled = false
    this.loadData('./static/json/scene.json')
  }

  /**
   * 加载场景相关数据
   * @param {string} url
   */
  loadData(url) {
    let xhr = new XMLHttpRequest()
    xhr.open('get', url)
    xhr.onreadystatechange = event => {
      // 数据请求完成
      if (xhr.readyState === 4 && xhr.status === 200) {
        try {
          let data = JSON.parse(xhr.responseText)
          this.sceneData = data
        } catch (err) {
          console.warn('场景数据加载失败')
          return
        }
        this.loadTextures()
      }
    }
    xhr.send()
  }

  /**
   * 添加素材
   */
  loadTextures() {
    let tMana = TextureRes.getInstace()
    let textures = this.sceneData.textures || []
    textures.forEach(element => {
      tMana.addResItem(element)
    })
    tMana.startLoad()
    // 素材加载完成
    tMana.addEventListener(OEEvents.LOAD_COMPLETE, () => {
      this.initPano()
    })
  }

  /**
   * 创建天空盒子
   */
  initPano() {
    // 天空盒网格
    this.skyGeo = new SphereBufferGeometry(
      PANO_CONFIG.PAN_RATIO,
      PANO_CONFIG.PAN_W_SEG,
      PANO_CONFIG.PAN_H_SEG
    )
    // 天空盒材质
    this.skyMaterial = new MeshBasicMaterial({
      map: null,
      side: BackSide
    })
    this.skyMesh = new Mesh(this.skyGeo, this.skyMaterial)
    this.skyMesh.scale.copy(PANO_CONFIG.PAN_MESH_SCALE)
    this.add(this.skyMesh)
    // 全景切换管理
    this.panoSwitch = new PanoSwitch(
      this.sceneData,
      this.skyMaterial,
      this.renderMain,
      this.camera,
      this.dom,
      this
    )
    this.enabled = true
  }
  update(delta_) {
    // 场景尚未准备好
    if (!this.enabled) return
    this.panoSwitch.update(delta_)
  }
}
export { PanoScene }



// WEBPACK FOOTER //
// ./src/webgl/panorama/PanoScene.js